import { styles } from 'containers/MyHealth/components/MedicationsPrintModal/styles.js'
import { MINIMUM_FONT_SIZE } from 'styles/typography'
import colors from 'styles/colors'

export const style = {
  fieldName: {
    fontSize: MINIMUM_FONT_SIZE,
    fontWeight: 700,
    textTransform: 'uppercase',
    textWrap: 'wrap'
  },
  medicationUppercase: {
    fontSize: MINIMUM_FONT_SIZE,
    fontWeight: 700,
    textTransform: 'uppercase',
    textWrap: 'wrap'
  },
  noPadding: {
    padding: 0
  },
  immunizationNoPaddingTop: isFirst => {
    return {
      paddingTop: !isFirst && 0,
      marginTop: '-0.5rem'
    }
  },
  immunizationName: {
    fontSize: 14,
    textWrap: 'wrap',
    marginLeft: 16,
    width: '100%',
    overflowWrap: 'break-word'
  },
  vaccineName: {
    fontSize: 14,
    textWrap: 'wrap',
    marginLeft: 32,
    width: '100%'
  },
  immunizationDatesOnFile: {
    fontSize: 14,
    textWrap: 'wrap',
    textAlign: 'right',
    marginRight: 32,
    width: '100%'
  },
  immunizationDate: {
    fontSize: 14,
    textWrap: 'wrap',
    textAlign: 'right',
    marginRight: 16
  },
  printLayout: {
    position: 'relative',
    background: '#FFFFFF',
    height: 1050
  },
  printLayoutSafari: {
    position: 'relative',
    background: '#FFFFFF',
    height: 880
  },
  printLayoutInIos: {
    position: 'relative',
    background: '#FFFFFF',
    height: 900
  },
  printLayoutHeader: {
    minHeight: 240,
    padding: 0,
    background: 'none'
  },
  printLayoutCommonHeader: {
    minHeight: 140,
    padding: 0,
    background: 'none'
  },
  printLayoutContent: {
    height: 'calc(100% - 390px)',
    padding: 0,
    overflow: 'hidden'
  },
  printLayoutFooter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    minHeight: 160,
    padding: 0,
    background: 'none'
  },
  printContainer: {
    width: 715,
    height: 0,
    overflow: 'hidden'
  },
  printerIcon: {
    transform: 'scaleX(-1)'
  },
  downLoadButton: {
    color: colors.white,
    backgroundColor: colors.primary,
    textTransform: 'uppercase',
    lineHeight: 'revert',
    borderRadius: 25
  },
  vaccineItem: {
    fontWeight: 700,
    fontSize: 10,
    textTransform: 'uppercase'
  },
  dateItem: {
    fontWeight: 700,
    fontSize: 10,
    textTransform: 'uppercase',
    textAlign: 'right'
  },
  date: {
    textAlign: 'right',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all'
  },
  medicationPrintItem: {
    overflow: 'hidden'
  },
  ...styles,
  header: { ...styles.header, padding: 0 }
}

export const themeStyles = colors => {
  const downLoadButton = {
    color: colors.white,
    backgroundColor: colors.primary,
    textTransform: 'uppercase',
    lineHeight: 'revert',
    borderRadius: 25
  }
  return { downLoadButton }
}

